import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'workpossibility'
})
export class WorkpossibilityPipe implements PipeTransform {

  transform(wp: unknown): unknown {
    switch(wp){
      case 'part-time':
        return 'Osa-aikainen';
      case 'trainee':
        return 'Harjoittelu';
      case 'full-time':
        return 'Vakituinen';
      case 'buy-service':
        return 'Keikka';
      case 'negotiable':
        return 'Sovittavissa';
      case 'summer-job':
        return 'Kesätyö';
      case 'specialty':
        return 'Erikoistuminen';
      case 'self-employed':
        return 'Ammatinharjoittaja';
      case 'service':
        return 'Virka';
      case 'tele':
        return 'Etätyö';
      case 'indenture':
        return 'Oppisopimus';
      case 'fixed-term':
        return 'Määräaikainen';
      default:
        return 'Ei määritelty';
    }
  }

}
